const properties = `url
caption
link
alt
width
height
ratio`

export default properties
